import { z } from 'zod';
import { ExportFormatSchema, JobStatusSchema } from './enums.js';

export const ExportRecordSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  assessmentId: z.string(),
  format: ExportFormatSchema,
  status: JobStatusSchema,
  error: z.string().nullable(),
  requestedBy: z.string(),
  createdAt: z.string(),
  completedAt: z.string().nullable(),
});
export type ExportRecord = z.infer<typeof ExportRecordSchema>;

export const CreateExportInputSchema = z.object({
  format: ExportFormatSchema,
});
export type CreateExportInput = z.infer<typeof CreateExportInputSchema>;
